<template>
  <div class="workflow-form">
    <baseFrame
      save-text=""
      cancel-text=""
      :clear-text="editable ? '取消': ''"
      :submit-text="editable ? '提交' : ''"
      :infos-arr="infos"
      :id="id"
      :id-text="id ? '审批流ID' : ''"
      :submit-loading="formLoading"
      @clear="handleCancelEdit"
      @submit="handleSubmit">
      <div slot="content">
        <lk-card class="mb16" :title="(editable ? '':'当前') + '审批流信息'">
          <div slot="extra" v-show="id && !editable">
            <lk-button type="primary" size="small" @click="handleCreateVersion">创建新版本</lk-button>
          </div>
          <lk-form
            v-show="editable"
            ref="form"
            label-position="right"
            :model="formModel"
            :rules="formRules"
            :label-width="114">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="审批流名称:" prop="name">
                  <lk-input v-model.trim="formModel.name"></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="状态:" prop="status">
                  <lk-select v-model="formModel.status" clearable>
                    <lk-option v-for="item in statusMap" :key="item[0]" :value="item[0]"
                               :label="item[1]"></lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="适用门店:" prop="storeIdList">
                  <lk-select v-model="formModel.storeIdList" clearable multiple filterable>
                    <lk-option v-for="item in storeList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="适用单据:" prop="bizTypeList">
                  <lk-select v-model="formModel.bizTypeList" clearable multiple filterable>
                    <lk-option v-for="item in bizTypeList" :key="item.id" :value="item.businessType">{{item.name}}</lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="审批级别:" prop="allNode">
                  <lk-select v-model="formModel.allNode" clearable @on-change="handleChangeApproveLevel">
                    <lk-option v-for="item in 10" :key="item" :value="item">{{item}}级</lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="角色设置:" prop="roleList">
                  <div class="step-background workflow-step">
                    <div class="ivu-steps ivu-steps-horizontal">
                      <div class="ivu-steps-item ivu-steps-status-wait"
                           v-for="(item, index) in stepList"
                           :key="index"
                           :style="{width: (1 / stepList.length * 100) + '%'}">
                        <div class="ivu-steps-tail"><i></i></div>
                        <div class="ivu-steps-head">
                          <div class="ivu-steps-head-inner">
                            <span class="iconfont">&#xe640;</span>
                          </div>
                        </div>
                        <div class="ivu-steps-main">
                          <div class="ivu-steps-title">{{item.title}}</div>
                          <div class="ivu-steps-content">
                            <lk-select v-model="item.roleId" clearable placeholder="请选择" filterable @on-change="handleValidRoleList">
                              <lk-option
                                v-for="status in roleList"
                                :key="status.id"
                                :value="status.id"
                                :label="status.name">
                              </lk-option>
                            </lk-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
          <lk-form
            v-show="!editable"
            label-position="right"
            :label-width="114">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="审批流名称:">
                  <span>{{formModel.name}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="状态:">
                  <span>{{statusMap.get(formModel.status)}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="适用门店:" prop="storeIdList">
                  <span>{{formModel.storeIdNameListStr}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="适用单据:">
                  <span>{{formModel.bizTypeNameListStr}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="审批级别:">
                  <span>{{formModel.allNode}}级</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="角色设置:" prop="roleList">
                  <div id="step-background" class="workflow-step step-background">
                    <div class="ivu-steps ivu-steps-horizontal">
                      <div class="ivu-steps-item ivu-steps-status-wait"
                           v-for="(item, index) in stepList"
                           :key="index"
                           :style="{width: (1 / stepList.length * 100) + '%'}">
                        <div class="ivu-steps-tail"><i></i></div>
                        <div class="ivu-steps-head">
                          <div class="ivu-steps-head-inner">
                            <span class="iconfont">&#xe640;</span>
                          </div>
                        </div>
                        <div class="ivu-steps-main">
                          <div class="ivu-steps-title">{{item.title}}</div>
                          <div class="ivu-steps-content">
                            <span>{{item.roleName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="版本信息" v-if="id">
          <lk-table border :columns="columns" :data="tableData"></lk-table>
        </lk-card>
      </div>
    </baseFrame>
    <!-- 未完成的单据 start -->
    <lk-modal
      v-model="listRecord.visiable"
      :mask-closable="false"
      :title="'审批流名称：'+ listRecord.name + '  版本号：' + listRecord.version"
      width="900">
      <div style="position: relative;">
        <loadingSpin v-show="modalLoading"></loadingSpin>
        <lk-table
          class="mb16"
          border
          min-height="400"
          max-height="500"
          :columns="billsColumn"
          :data="billsTableData">
        </lk-table>
        <div style="text-align:right">
          <lk-page
            :total="count"
            :current="page"
            :page-size="size"
            size="small"
            show-sizer
            show-elevator
            show-total
            transfer
            @on-change="handlePage"
            @on-page-size-change="handlePageSize">
          </lk-page>
        </div>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <lk-button @click="listRecord.visiable = false">关闭</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 未完成的单据 end -->
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import workflow from '../../services/workflow';
import system from '../../services/system';
import utils from '../../libs/utils';
import loadingSpin from '../../components/LoadingSpan';

export default {
  name: 'WorkflowForm',
  components: {
    baseFrame,
    loadingSpin,
  },
  data() {
    return {
      id: '',
      infos: [],
      currentStep: '',
      stepList: [],
      formLoading: false,
      modalLoading: false,
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      roleList: [],
      bizTypeList: [],
      storeList: [],
      formModel: {
        name: null,
        status: 2, // 默认禁用
        storeIdList: [],
        bizTypeList: [],
        allNode: null,
        // roleList: null,
      },
      editable: false,
      formRules: {
        name: [
          {
            required: true,
            message: '请输入审批流名称',
          },
          // { validator: this.nameExistValidator, trigger: 'blur' },
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
          },
        ],
        storeIdList: [
          {
            required: true,
            message: '请选择适用门店',
          },
        ],
        bizTypeList: [
          {
            required: true,
            message: '请选择适用单据',
          },
        ],
        allNode: [
          {
            required: true,
            message: '请选择审批级别',
          },
        ],
        roleList: [
          {
            required: true,
            message: '请进行角色设置',
            // trigger: 'blur',
          },
          {
            validator(rule, value, callback) {
              if (value === -1) {
                callback(new Error('角色不能重复'));
              } else {
                callback();
              }
            },
            message: '角色不能重复',
          },
        ],
      },
      page: 1,
      size: 10,
      count: 0,
      params: {},
      columns: [
        {
          title: '版本号',
          key: 'versionStr',
          width: 80,
        },
        {
          title: '审批流名称',
          key: 'name',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '适用门店',
          key: 'storeIdNameListStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '适用单据',
          key: 'bizTypeNameListStr',
          minWidth: 116,
        },
        {
          title: '审批级别',
          key: 'allNode',
          minWidth: 116,
        },
        {
          title: '审批角色',
          key: 'workRoleNameListStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 116,
          render: (h, { row }) => h('lk-switch', {
            props: {
              size: 'large',
              value: row.status === 1,
              loading: row.loading,
            },
            on: {
              'on-change': (value) => {
                row.loading = true;
                const finalFn = value ? workflow.setWorkflowStatusEnable : workflow.setWorkflowStatusDisable;
                finalFn({
                  id: row.id,
                }).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success(value ? '该审批流已启用' : '该审批流已禁用');
                    row.status = value ? 1 : 2;
                    this.getData();
                  } else {
                    this.$Message.error({
                      content: res.data.error,
                      duration: 3,
                      closable: true,
                    });
                    this.getData();
                  }
                  row.loading = false;
                }).catch((err) => {
                  this.getData();
                  utils.handleError(err);
                });
              },
            },
          }, [
            h('span', {
              slot: 'open',
            }, '启用'),
            h('span', {
              slot: 'close',
            }, '禁用'),
          ]),
        },
        {
          title: '未结束单据数',
          key: 'unFinishNum',
          minWidth: 116,
          render: (h, { row }) => {
            const vm = this;
            return row.unFinishNum ? h('a',
              {
                prop: {},
                style: {},
                on: {
                  click() {
                    vm.listRecord.visiable = true;
                    vm.listRecord.name = row.name;
                    vm.listRecord.version = row.versionStr;
                    vm.params.workId = row.id;
                    vm.handleQueryUnFinishData();
                  },
                },
              }, row.unFinishNum) : h('span', 0);
          },
        },
        {
          title: '创建时间',
          key: 'createTimeStr',
          minWidth: 116,
        },
        {
          title: '最后启用时间',
          key: 'lastEnableTimeStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      listRecord: {
        visiable: false,
        name: '',
        version: '',
      },
      billsColumn: [
        {
          title: '序号',
          type: 'index',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '单据类型',
          key: 'workRecordBizTypeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '当前节点',
          key: 'workRecordRoleName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '当前审批人',
          key: 'auditNameListStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '标题',
          key: 'workRecordTitle',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '提交人',
          key: 'workRecordCreateUserName',
          minWidth: 116,
          tooltip: true,
        },
      ],
      billsTableData: [],
    };
  },
  computed: {},
  methods: {
    getData() {
      workflow.getWorkflowInfo({ code: this.id }).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          // 找到当前启用状态的数据
          let enableNum = 0;
          list.forEach((item) => {
            const params = item.workPermission;
            params.bizTypeList = item.bizTypeList;
            params.storeIdList = item.storeIdList;
            params.bizTypeNameListStr = item.bizTypeNameList && item.bizTypeNameList.join(';'); // 适用单据
            params.storeIdNameList = [];
            // 适用门店名称
            item.sysStoreList.forEach((store) => {
              params.storeIdNameList.push(store.name);
            });
            params.storeIdNameListStr = params.storeIdNameList.join(';');

            params.stepList = [];
            params.workRoleNameList = [];
            item.workRoleRelList.forEach((role) => {
              let roleName = '';
              this.roleList.forEach((roleItem) => {
                if (role.roleId === roleItem.id) {
                  roleName = roleItem.name;
                  params.workRoleNameList.push(roleName);
                }
              });

              params.stepList.push({
                title: `${role.node}级审批人`,
                roleId: role.roleId,
                roleName,
              });
            });
            params.unFinishNum = item.unFinishNum;
            params.roleList = params.workRoleNameList.length;
            params.workRoleNameListStr = params.workRoleNameList.join(';');
            params.versionStr = `v${params.version.toFixed(1)}`;
            params.createTimeStr = utils.formatTime(params.createTime);
            params.lastEnableTimeStr = utils.formatTime(params.lastEnableTime) || '-';

            // 启用的审批流
            if (params.status === 1) {
              enableNum++;
              this.formModel = utils.deepClone(params);
              this.stepList = this.formModel.stepList; // 角色设置
              this.setInfos(params);
            }
            this.tableData.push(params);
          });

          // 都是禁用
          if (enableNum === 0) {
            const firstFlow = utils.deepClone(this.tableData[0]);
            this.formModel = firstFlow;
            this.stepList = firstFlow.stepList;
            this.setInfos(firstFlow);
          }
          this.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getBizTypeList() {
      return new Promise((resolve) => {
        workflow.bussinessTypes().then((res) => {
          if (res.data.status === 200) {
            this.bizTypeList = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getRoleList() {
      return new Promise((resolve) => {
        const params = {
          page: 1,
          size: 1000,
          status: 1, // 启用状态
        };
        system.roleList(params).then((res) => {
          if (res.data.status === 200) {
            this.roleList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getStores() {
      return new Promise((resolve) => {
        system.listStoresEnable().then((res) => {
          if (res.data.status === 200) {
            this.storeList = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    // 设置【角色设置】对应级别的审批人
    handleChangeApproveLevel(value) {
      /*
      * 1.新设置的级别比之前的级别少，直接保留到新级别的数据
      * 2.新设置的级别比之前的级别多，保留之前的数据，新增空数据
      * */
      const len = this.stepList.length;
      console.log(value);
      if (len > value) {
        this.stepList.length = value;
      } else {
        for (let i = 1 + len; i <= value; i++) {
          this.stepList.push({
            title: `${i}级审批人`,
            roleId: '',
          });
        }
      }
    },
    // 设置【角色设置】对应的验证状态
    handleValidRoleList(value) {
      /*
      * 如果存在重复，数字被置成了-1
      * */
      const payloadNum = value ? 1 : -1;
      this.formModel.roleList = Number(this.formModel.roleList || 0) + payloadNum;
      if (value) {
        let num = 0;
        this.stepList.forEach((item) => {
          if (item.roleId === value) {
            num++;
          }
        });
        if (num > 1) {
          this.formModel.roleList = -1; // 存在相同的角色
        }
      } else {
        let num = 0;
        this.stepList.forEach((item) => {
          if (item.roleId) {
            num++;
          }
        });
        this.formModel.roleList = num || '';
      }
    },
    nameExistValidator(rule, value, callback) {
      if (this.id) {
        callback();
        return;
      }

      this.$store.commit('setDisableLoading', true);
      workflow.getWorkflowCheckName({ name: value }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data) {
            callback(new Error('该审批流名称已经存在'));
          } else {
            callback();
          }
        } else {
          this.$Message.error(res.data.error);
          callback();
        }
      }).catch((err) => {
        utils.handleError(err);
        callback();
      });
    },
    handleToList() {
      this.$router.push({
        name: 'workflowList',
      });
    },
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            workPermission: {
              code: this.id,
              name: this.formModel.name,
              status: this.formModel.status,
              allNode: this.formModel.allNode,
            },
            bizTypeList: this.formModel.bizTypeList,
            sysStoreList: [], // 适用门店
            workRoleRelList: [], // 角色设置
          };

          // 组装适用门店
          this.storeList.forEach((item) => {
            if (this.formModel.storeIdList.includes(item.id)) {
              params.sysStoreList.push({
                id: item.id,
                name: item.name,
              });
            }
          });

          // 组装角色设置
          this.stepList.forEach((item, index) => {
            params.workRoleRelList.push({
              node: index + 1,
              roleId: item.roleId,
            });
          });

          const finalFormAction = this.id ? workflow.workflowUpdate : workflow.workflowSave;

          this.formLoading = true;
          finalFormAction(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success(this.id ? '更新成功' : '保存成功');
              this.handleToList();
            } else {
              this.$Message.error({
                content: res.data.error,
                duration: 3,
                closable: true,
              });
            }
            this.formLoading = false;
          }).catch((err) => {
            this.formLoading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
    setInfos(item) {
      this.infos = [
        {
          name: '创建人:',
          value: item.createUserName,
        },
        // {
        //   name: '创建时间:',
        //   value: utils.formatTime(item.createTime),
        // },
        {
          name: '最后修改人:',
          value: item.modifiedUserName,
        },
        // {
        //   name: '最后修改时间:',
        //   value: utils.formatTime(item.modifiedTime),
        // },
      ];
    },
    handleCreateVersion() {
      this.editable = true;
      this.formModel.status = 2;
    },
    handleCancelEdit() {
      if (this.id) {
        this.editable = false;
        this.getData();
      } else {
        this.handleToList();
      }
    },
    handleQueryUnFinishData() {
      this.page = 1;
      this.size = 10;
      this.getunFinishData();
    },
    getunFinishData() {
      this.modalLoading = true;
      this.params.page = this.page;
      this.params.size = this.size;
      workflow.getWorkflowListRecord(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.billsTableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.auditNameListStr = result.auditNameList && result.auditNameList.join(';');
            this.billsTableData.push(result);
          });
          this.count = count;
          this.modalLoading = false;
          this.listRecord.visiable = true;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    handlePageSize(val) {
      this.size = val;
      this.getunFinishData();
    },
    handlePage(val) {
      this.page = val;
      this.getunFinishData();
    },
  },
  created() {
    Promise.all([this.getBizTypeList(), this.getRoleList(), this.getStores()]).then(() => {
      if (this.$route.params && this.$route.params.id) {
        this.id = this.$route.params.id;
      }
      if (this.id) { // 编辑
        this.getData();
      } else {
        this.editable = true; // 新建
      }
    });
  },
};
</script>
<style lang="less" scoped>
</style>
